import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
  viewStatus: {
    trafficLayer:true,
    tollStation: false,
    serviceArea: true,
    // planEvent: true,
    trafficEvent: false,
    weather: false,
  },
  layer:{
    showConfigLayer:false
  },
  scenicSpot:{
    city:"兰州"
  }
};
export default new Vuex.Store({
  state,
  mutations:{
    //更新地图试图状态
    updateViewStatus(state,data){
      state.viewStatus=data;
    },
    //更新路况图层状态
    updateTrafficLayer(state,data){
      state.viewStatus.trafficLayer=data;
    },
    //更新图层控制面板状态
    updateConfigLayer(state,data){
      state.layer.showConfigLayer=data;
    },
    //更新景点选择的城市
    updateScenicSpotCity(state,data){
      state.scenicSpot.city=data
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/StoreConfig.js